import React from 'react';
import { css } from '@emotion/react';
import { i18n_breathwork_to_enhance_vitality } from '@yi/i18n/phrases/i18n_breathwork_to_enhance_vitality';
import { i18n_continuing_ed_courses_for_credits } from '@yi/i18n/phrases/i18n_continuing_ed_courses_for_credits';
import { i18n_docs_films_for_deeper_insight } from '@yi/i18n/phrases/i18n_docs_films_for_deeper_insight';
import { i18n_guided_meditations_to_elevate_your_soul } from '@yi/i18n/phrases/i18n_guided_meditations_to_elevate_your_soul';
import { i18n_online_yoga_practices_for_every_body } from '@yi/i18n/phrases/i18n_online_yoga_practices_for_every_body';

import { Bold } from '~/src/components/i18n/Bold';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints, fontWeight } from '~/src/styles';
import { typography } from '~/src/styles/design-system';
import { resetStyles } from '~/src/styles/reset-styles-mixins';

import { commonStyles } from './common-styles';

const styles = {
  list: css(resetStyles.ul, commonStyles.contentPadding, {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'var(--Section-Padding)',
    [breakpoints.minTablet]: {
      width: 'fit-content',
      margin: 'auto',
    },
    li: css(typography.label, {
      color: 'var(--Grey-Text, #585858)',
      borderBottom: '1px solid var(--Grey-Background)',
      padding: '16px 0',
      [breakpoints.minTablet]: [
        typography.bodyText,
        {
          color: 'var(--Grey-Text, #585858)',
        },
      ],
      [breakpoints.minDesktop]: {
        color: 'var(--Grey-Text, #585858)',
        fontSize: '28px',
        fontWeight: fontWeight.medium,
        lineHeight: '40px',
        letterSpacing: '1.4px',
        padding: '24px 0',
      },
    }),
    'li:first-of-type': css({
      paddingTop: '0',
    }),
  }),
};

export const FeatureList: React.FC = () => {
  const { locale } = useLocale();

  return (
    <ul css={styles.list}>
      <li>{i18n_online_yoga_practices_for_every_body(locale, { transformFn: Bold })}</li>
      <li>{i18n_guided_meditations_to_elevate_your_soul(locale, { transformFn: Bold })}</li>
      <li>{i18n_breathwork_to_enhance_vitality(locale, { transformFn: Bold })}</li>
      <li>{i18n_docs_films_for_deeper_insight(locale, { transformFn: Bold })}</li>
      <li>{i18n_continuing_ed_courses_for_credits(locale, { transformFn: Bold })}</li>
    </ul>
  );
};
